// extracted by mini-css-extract-plugin
export default {"table":"OffersTable_table__mBbmj"};